import React from 'react'

const MIN_REASON_DETAIL_LEN = 20

const normalizeReasonDetail = (value) => String(value || '').replace(/\s+/g, ' ').trim()

export default function MutationReasonModal({
  show,
  pendingMutationAction,
  mutationReasonDraft,
  setMutationReasonDraft,
  mutationReasonWeak,
  onClose,
  onConfirm,
}) {
  if (!show) return null

  return (
    <div className="fixed inset-0 z-[78] flex items-center justify-center bg-slate-950/70 p-4 backdrop-blur-sm" onClick={onClose}>
      <div className="w-full max-w-lg rounded-2xl border border-white/20 bg-slate-900/95 p-5 text-slate-100" onClick={(e) => e.stopPropagation()}>
        <p className="text-lg font-semibold text-white">Justificacion pericial obligatoria</p>
        <p className="mt-1 text-xs text-slate-300">Este ajuste quedara registrado en el historial inmutable del expediente.</p>
        <div className="mt-3 space-y-2">
          <label className="block text-xs text-slate-300">
            Motivo legal
            <select
              value={mutationReasonDraft.reasonCode}
              onChange={(e) => setMutationReasonDraft((p) => ({ ...p, reasonCode: e.target.value }))}
              className="mt-1 h-9 w-full rounded border border-white/25 bg-slate-900/60 px-2 text-white"
            >
              <option value="exclusion_moratoria">Exclusion por moratoria</option>
              <option value="ajuste_autonomo_mackler">Ajuste autonomo (Mackler)</option>
              <option value="correccion_ocr">Correccion OCR</option>
              <option value="ajuste_manual_perito">Ajuste manual del perito</option>
            </select>
          </label>
          <label className="block text-xs text-slate-300">
            Justificacion
            <textarea
              value={mutationReasonDraft.reasonDetail}
              onChange={(e) => setMutationReasonDraft((p) => ({ ...p, reasonDetail: e.target.value }))}
              className="mt-1 min-h-[90px] w-full rounded border border-white/25 bg-slate-900/60 p-2 text-white"
              placeholder="Indique fundamento tecnico-juridico del ajuste"
            />
            <p className={`mt-1 text-[11px] ${mutationReasonWeak ? 'text-rose-300' : 'text-emerald-300'}`}>
              {normalizeReasonDetail(mutationReasonDraft.reasonDetail).length}/{MIN_REASON_DETAIL_LEN} caracteres mínimos.
            </p>
          </label>
        </div>
        <div className="mt-4 flex justify-end gap-2">
          <button type="button" onClick={onClose} className="panel-profile rounded-xl px-4 py-2 text-sm">Cancelar</button>
          <button type="button" onClick={onConfirm} disabled={mutationReasonWeak} className="btn-profile-soft rounded-xl px-4 py-2 text-sm font-semibold disabled:opacity-40">Confirmar y registrar</button>
        </div>
      </div>
    </div>
  )
}
